/**
 * The clips already on the feed.
 *
 * A silent app is a one-note gag: a visitor submits, gets clipped, leaves.
 * DiceTok has to look ALIVE for the joke to land — the comedy is that this is
 * a busy platform where every single clip is exactly four seconds of someone
 * taken out of context.
 *
 * Static and hand-written. Nothing user-submitted is ever stored, so the feed
 * cannot come from anywhere else, and that constraint is the premise.
 */

export interface Clip {
  id: string
  handle: string
  caption: string
  likes: number
  comments: number
  stitches: number
  age: string
  pinned?: boolean
}

export const DURATION = '0:04'

export const CLIPS: Clip[] = [
  {
    id: 'c0',
    handle: '@ClippyJack',
    caption:
      'every clip on this app is four seconds of someone’s worst second. that’s not a bug, that’s the format. 🚩 #FYP #NoNotes #ContextIsACopingMechanism',
    likes: 812400,
    comments: 0,
    stitches: 41200,
    age: 'pinned',
    pinned: true,
  },
  {
    id: 'c1',
    handle: '@boardgamebarry.exposed',
    caption:
      'WAIT FOR IT — the pause before he answers 😳 he KNEW. #FounderExposed #TabletopTea #Watching',
    likes: 204100,
    comments: 0,
    stitches: 9800,
    age: '2h',
  },
  {
    id: 'c2',
    handle: '@stitchprophet',
    caption:
      'stitching his "apology" bc babe. BABE. that was not an apology, that was a stall tactic with a ring light. 🎙️ #Duet #Accountability #StillWaiting',
    likes: 55600,
    comments: 0,
    stitches: 3100,
    age: '4h',
  },
  {
    id: 'c3',
    handle: '@dance4dice',
    caption:
      'did the little shimmy every time a d20 lands nat 1 at the table, no context needed, just vibes 💀 #ForYou #TabletokChallenge',
    likes: 1200300,
    comments: 0,
    stitches: 210900,
    age: '6h',
  },
  {
    id: 'c4',
    handle: '@actualplaygrind',
    caption:
      'day 340 of posting our home game hoping Stream of Consciousness notices. today’s clip: the DM forgot a name. RAW. #Indie #FarmTeam #PickUsUp',
    likes: 890,
    comments: 0,
    stitches: 12,
    age: '9h',
  },
  {
    id: 'c5',
    handle: '@ClippyJack',
    caption:
      'someone in my comments asked for "the rest of the clip." there is no rest of the clip. there was never a rest of the clip. 👀 #Explainer #StillExposed',
    likes: 340200,
    comments: 0,
    stitches: 18700,
    age: '1d',
  },
]

/** Comment counts are always zero. Every reply is a moment too. */
export const COMMENTS_ARE_DISABLED_REASON =
  'Comments are moments. Moments get clipped. None have shown the full four seconds.'
